import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { LocationActivityTableColumn } from "./Column";
import { LocationActivityTableDetailsSection } from "./DetailsSection";
import { useMe } from "../../../../hooks/queries";
import { AccountType } from "../../../../models/AccountData";
import { LocationActivityLog } from "../../../../models/LocationActivityLog";
import { CommonLink } from "../../../Common/CommonLink";
import "./styles.scss";

interface LocationActivityTableRowProps {
  locationActivityLog?: LocationActivityLog;
  isHeader?: boolean;
  sortField?: string;
  sortDirection?: string;
  handleSort?: (sortField: string) => void;
}

export const LocationActivityTableRow: React.FunctionComponent<
  LocationActivityTableRowProps
> = ({
  locationActivityLog,
  isHeader,
  sortField,
  sortDirection,
  handleSort,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`locationActivityPage.locationActivityTable.${key}`);

  const { data: me } = useMe();
  const isAdmin = me?.type === AccountType.ADMIN;

  return (
    <div
      className={`location-activity-table-row ${
        isHeader ? "location-activity-table-header" : ""
      }`}
    >
      <div className="top-row">
        <LocationActivityTableColumn
          isHeader={isHeader}
          handleSort={handleSort}
          sortField="activity_date"
          headerText={t("header.date")}
          itemText={dayjs(locationActivityLog?.activity_date).format(
            "YYYY/MM/DD HH:mm"
          )}
          currentSortField={sortField}
          currentSortDirection={sortDirection}
        />
        <LocationActivityTableColumn
          isHeader={isHeader}
          handleSort={handleSort}
          sortField="location"
          headerText={t("header.location")}
          currentSortField={sortField}
          currentSortDirection={sortDirection}
        >
          <CommonLink
            to={`/location/${locationActivityLog?.location?.id}/${
              me?.organization_id ? `organization/${me?.organization_id}` : ""
            }`}
          >
            {locationActivityLog?.location?.name || "-"}
          </CommonLink>
        </LocationActivityTableColumn>
        {isAdmin && (
          <LocationActivityTableColumn
            isHeader={isHeader}
            handleSort={handleSort}
            sortField="user"
            headerText={t("header.user")}
            itemText={locationActivityLog?.created_by?.name}
            currentSortField={sortField}
            currentSortDirection={sortDirection}
          />
        )}
        <LocationActivityTableColumn
          isHeader={isHeader}
          handleSort={handleSort}
          sortField="type"
          headerText={t("header.type")}
          itemText={t(`type.${locationActivityLog?.type}`) || "-"}
          currentSortField={sortField}
          currentSortDirection={sortDirection}
        />
        <LocationActivityTableDetailsSection
          isHeader={isHeader}
          activityLog={locationActivityLog}
        />
        {/* TODO: Will open til next sprint, should consider the user's type. */}
        {/* <LocationActivityTableActionButton
          isHeader={isHeader}
          activityLog={locationActivityLog}
        /> */}
      </div>
    </div>
  );
};
